import script from "./deleteLineRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./deleteLineRegistration.vue?vue&type=script&setup=true&lang=js"

import "./deleteLineRegistration.vue?vue&type=style&index=0&id=2230615e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2230615e"]])

export default __exports__